'use client';

import {emitYmEvent, logTmrEvent} from './logEvent';

export const logBreadcrumbsItemClick = (buttonText: string) => {
  emitYmEvent({
    eventName: 'appPage_breadCrumbs_click',
  });

  logTmrEvent({
    logEvent: 'appPage.breadCrumbs.click',
    params: {
      button_text: buttonText,
    },
  });
};
